export default {"src":"/_next/static/media/article_placeholder.895a54c8.svg","height":169,"width":300,"blurWidth":0,"blurHeight":0};